import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Action } from '@ngrx/store';

// Store
import { loadWidgetData, loadWidgetDataSuccess, loadWidgetDataError } from './widget.actions';

// Services
import { WidgetsService } from '@services/widgets.service';
import { ThemeService } from '@services/theme/theme.service';

// Models
import { LOCAL_STORAGE_KEYS } from '@constants/storage.constants';

@Injectable()
export class WidgetEffects implements OnInitEffects {
  private readonly actions$ = inject(Actions);
  private readonly widgetsService = inject(WidgetsService);
  private readonly themeService = inject(ThemeService);

  ngrxOnInitEffects(): Action {
    const widgetId = this.widgetsService.getWidgetId();
    if (!widgetId) {
      return { type: '[Widget] Init noop' };
    }

    sessionStorage.setItem(LOCAL_STORAGE_KEYS.WIDGET_ID, widgetId.toString());
    return loadWidgetData({ widgetId });
  }

  loadWidgetData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadWidgetData),
      switchMap(({ widgetId }) =>
        this.widgetsService.getWidgetDataFromServer(widgetId).pipe(
          map(widgetData => {
            this.themeService.setCustomTheme(widgetData);

            if (widgetData?.homeowner_access) {
              localStorage.setItem(LOCAL_STORAGE_KEYS.HOMEOWNER_ACCESS, '1');
            } else {
              localStorage.removeItem(LOCAL_STORAGE_KEYS.HOMEOWNER_ACCESS);
            }

            return loadWidgetDataSuccess({ data: widgetData });
          }),
          catchError(error => {
            localStorage.removeItem(LOCAL_STORAGE_KEYS.HOMEOWNER_ACCESS);
            return of(loadWidgetDataError({ error }));
          }),
        ),
      ),
    ),
  );
}
